// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====== 사용자 홈 (에이전트 런처) ====== */

/* 브랜드 네이비 로컬 토큰 — 랜딩(.landing)·제품(.gf-showcase-page)과 동일 값.
   전역 토큰(보라 계열 primary/fg-purple)은 변경하지 않는다. */
.home {
  --home-navy: #13314f;
  --home-navy-ink: #0e1b2b;
  --home-navy-soft: #3c5a78;
  --home-navy-tint: #e7edf3;
  --home-navy-line: rgba(14, 27, 43, 0.1);
  --home-gov: #1a5e3a;
  --home-gov-tint: #e6f1ea;

  min-height: 100vh;
  background: var(--fg-bg-content, #f2f2f2);
}

.home__body {
  padding: 40px 32px 64px;
}
.home__inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* ── 인사 + 토큰 ── */
.home-greet {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  flex-wrap: wrap;
}
.home-greet__hello {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--home-navy-ink);
}
.home-greet__hello b {
  font-weight: 800;
}
.home-greet__sub {
  margin: 6px 0 0;
  font-size: 14px;
  color: var(--text-secondary);
}
.home-greet__token {
  min-width: 260px;
}
.home-greet__token-head {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 6px;
}
.home-greet__token-label {
  color: var(--text-secondary);
}
.home-greet__token-pct {
  font-weight: 700;
  color: var(--home-navy);
}
.home-greet__token-pct.is-low {
  color: var(--error, #dc2626);
}
.home-greet__token-bar {
  height: 6px;
  border-radius: 999px;
  background: var(--home-navy-tint);
  overflow: hidden;
}
.home-greet__token-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--home-navy);
  transition: width 0.3s ease;
}
.home-greet__token-fill.is-low {
  background: var(--error, #dc2626);
}
.home-greet__token-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.home-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.home-btn--primary {
  background: var(--home-navy);
  color: #fff;
}
.home-btn--primary:hover {
  background: var(--home-navy-ink);
}
.home-btn--ghost {
  background: #fff;
  color: var(--home-navy);
  border-color: var(--home-navy-line);
}
.home-btn--ghost:hover {
  background: var(--home-navy-tint);
}

/* ── 섹션 헤더 ── */
.home-section__head {
  margin-bottom: 18px;
}
.home-section__head--row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.home-section__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--home-navy-soft);
}
.home-section__title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: var(--home-navy-ink);
}
.home-section__title--sm {
  font-size: 16px;
}
.home-section__sub {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
}

/* ── 에이전트 그리드 ── */
.home-agent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}
.home-agent-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 14px;
  text-align: left;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease,
    border-color 0.15s ease;
}
.home-agent-card:hover {
  transform: translateY(-2px);
  border-color: var(--home-navy-soft);
  box-shadow: 0 12px 32px -16px rgba(14, 27, 43, 0.4);
}
.home-agent-card:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring, 0 0 0 2px var(--home-navy-soft));
}
.home-agent-card--supplier {
  border-color: var(--home-gov);
}
.home-agent-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
}
.home-agent-card__mark {
  width: 28px;
  height: 28px;
  display: inline-flex;
}
.home-agent-card__mark img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home-agent-card__badge {
  font-size: 11px;
  font-weight: 700;
  color: var(--home-navy);
  background: var(--home-navy-tint);
  border-radius: 999px;
  padding: 3px 10px;
}
.home-agent-card__badge--gov {
  color: var(--home-gov);
  background: var(--home-gov-tint);
}
.home-agent-card__name {
  margin: 2px 0 0;
  font-size: 17px;
  font-weight: 800;
  color: var(--home-navy-ink);
}
.home-agent-card__one {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.home-agent-card__starters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
}
.home-agent-card__starter {
  font-size: 12px;
  color: var(--home-navy);
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 999px;
  padding: 5px 11px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.home-agent-card__starter:hover {
  background: var(--home-navy-tint);
}
.home-agent-card__cta {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: var(--home-navy);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}
.home-agent-card__cta:hover {
  background: var(--home-navy-ink);
}

.home-explore-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  background: transparent;
  border: 1.5px dashed var(--home-navy-line);
  border-radius: 14px;
  color: var(--home-navy-soft);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.home-explore-card:hover {
  border-color: var(--home-navy-soft);
  background: #fff;
}
.home-explore-card__plus {
  font-size: 24px;
  line-height: 1;
}

/* ── 이어서 작업 ── */
.home-resume__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 12px;
}
.home-resume__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 12px;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.home-resume__item:hover {
  border-color: var(--home-navy-soft);
  box-shadow: 0 8px 20px -14px rgba(14, 27, 43, 0.4);
}
.home-resume__mark {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: inline-flex;
}
.home-resume__mark img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.home-resume__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.home-resume__head {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.home-resume__name {
  font-size: 14px;
  font-weight: 700;
  color: var(--home-navy-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-resume__status {
  flex: 0 0 auto;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.5;
  border: 1px solid transparent;
}
.home-resume__status--paused {
  color: #1d4ed8;
  background: #eff4ff;
  border-color: #d3e0ff;
}
.home-resume__status--running {
  color: #047857;
  background: #ecfdf5;
  border-color: #c8f0dd;
}
.home-resume__status--error {
  color: #b42318;
  background: #fef3f2;
  border-color: #fbd6d1;
}
.home-resume__sum {
  font-size: 12px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-resume__when {
  flex: 0 0 auto;
  font-size: 12px;
  color: var(--text-tertiary);
}
.home-resume__empty {
  margin: 0;
  padding: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--text-tertiary);
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 12px;
}

/* ── 모델 비교 배너 ── */
.home-compare {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 22px;
  background: var(--home-navy);
  color: #fff;
  border: none;
  border-radius: 14px;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease;
}
.home-compare:hover {
  background: var(--home-navy-ink);
}
.home-compare__icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 12px;
}
.home-compare__text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.home-compare__title {
  font-size: 16px;
  font-weight: 800;
}
.home-compare__sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
}
.home-compare__go {
  opacity: 0.8;
}

/* ── 공지사항 ── */
.home-notice__list {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 12px;
  overflow: hidden;
}
.home-notice__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-top: 1px solid var(--home-navy-line);
  cursor: pointer;
  transition: background 0.15s ease;
}
.home-notice__item:first-child {
  border-top: none;
}
.home-notice__item:hover {
  background: var(--home-navy-tint);
}
.home-notice__title {
  font-size: 14px;
  color: var(--home-navy-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.home-notice__date {
  flex: 0 0 auto;
  font-size: 12px;
  color: var(--text-tertiary);
}
.home-notice__empty {
  margin: 0;
  padding: 20px;
  font-size: 14px;
  color: var(--text-tertiary);
  background: #fff;
  border: 1px solid var(--home-navy-line);
  border-radius: 12px;
}

/* ── 푸터 ── */
.home-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding-top: 16px;
  border-top: 1px solid var(--home-navy-line);
  text-align: center;
}
.home-footer__links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
}
.home-footer__links a {
  font-size: 13px;
  color: var(--text-secondary);
  text-decoration: none;
}
.home-footer__links a:hover {
  color: var(--home-navy);
}
.home-footer__brand {
  display: flex;
  align-items: center;
  gap: 14px;
}
.home-footer__brand-img {
  height: 22px;
  object-fit: contain;
}
.home-footer__brand-img--bct {
  height: 18px;
  opacity: 0.85;
}
.home-footer__copy {
  margin: 0;
  font-size: 12px;
  color: var(--text-tertiary);
}

/* ── 반응형 ── */
@media (max-width: 720px) {
  .home__body {
    padding: 24px 16px 48px;
  }
  .home__inner {
    gap: 32px;
  }
  .home-agent-grid {
    grid-template-columns: 1fr;
  }
  .home-greet {
    flex-direction: column;
    align-items: stretch;
  }
  .home-greet__token {
    min-width: 0;
  }
}

/* ── 공지 상세 모달 ── */

/* 등장 애니메이션 */
@keyframes notice-overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes notice-modal-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 오버레이 — dialog와 sibling으로 분리, aria-hidden */
.notice-modal__overlay {
  position: fixed;
  inset: 0;
  /* 순수 블랙 → 브랜드 네이비 딥 오버레이 */
  background: rgba(14, 27, 43, 0.55);
  z-index: 1000;
  animation: notice-overlay-in 0.18s ease;
}

/* 모달 패널 — div.notice-modal[role="dialog"], 오버레이와 sibling */
.notice-modal {
  position: fixed;
  inset: 24px;
  margin: auto;
  width: min(720px, calc(100% - 48px));
  height: fit-content;
  max-height: calc(80vh - 48px);
  background: #ffffff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  /* 네이비 기반 directional shadow — 홈 카드 hover 패턴 참조 */
  box-shadow:
    0 0 0 1px var(--home-navy-line),
    0 24px 48px -16px rgba(14, 27, 43, 0.35);
  overflow: hidden;
  animation: notice-modal-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 1001;
}

.notice-modal__header {
  display: flex;
  align-items: flex-start; /* center → flex-start: 긴 제목 대응 */
  justify-content: space-between;
  gap: 12px;
  padding: 22px 24px 18px; /* 좌우 24px — 카드 내부와 동일 리듬 */
  /* border 대신 box-shadow로 — 스크롤 시 강화 전환을 위해 */
  box-shadow: 0 1px 0 var(--home-navy-line);
  transition: box-shadow 0.15s ease;
}

/* 바디 스크롤 시 헤더 하단 강조 */
.notice-modal__header--scrolled {
  box-shadow: 0 4px 12px -4px rgba(14, 27, 43, 0.12);
}

.notice-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 800; /* 700 → 800: 홈 섹션 타이틀과 동급 위계 */
  color: var(--home-navy-ink);
  line-height: 1.4;
  /* 단일행 ellipsis 제거 → 2줄 클램프 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.notice-modal__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--text-secondary);
  cursor: pointer;
  /* shorthand 대신 속성 명시 — 의도치 않은 전환 방지 */
  transition: background 0.15s ease, color 0.15s ease;
}

.notice-modal__close:hover {
  background: var(--home-navy-tint); /* rgba 블랙 → 네이비 틴트 */
  color: var(--home-navy-ink);
}

.notice-modal__close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--home-navy-soft); /* 홈 카드 focus-visible 패턴 */
}

.notice-modal__body {
  padding: 20px 24px 24px; /* 좌우 24px — 헤더와 수직 정렬 */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px; /* 12px → 16px: 메타/설명/본문 간 숨 확보 */
}

.notice-modal__status {
  margin: 0;
  padding: 24px 0;
  text-align: center;
  font-size: 14px;
  color: var(--text-secondary);
}

.notice-modal__status--error {
  color: var(--error, #dc2626);
}

.notice-modal__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.notice-modal__tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px; /* 9999px → 999px: 홈 배지와 통일 */
  background: var(--home-navy-tint);
  font-size: 12px;
  font-weight: 500;
  color: var(--home-navy);
  line-height: 1;
}

.notice-modal__tag--pin {
  background: var(--home-navy);
  color: #ffffff;
}

.notice-modal__date {
  margin-left: auto;
  font-size: 13px;
  color: var(--text-tertiary);
}

.notice-modal__description {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--home-navy-ink);
  white-space: pre-wrap;
}

.notice-modal__content-body {
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-primary);
  word-break: break-word;
}

.notice-modal__content-body p {
  margin: 0 0 12px;
}

.notice-modal__content-body h1,
.notice-modal__content-body h2,
.notice-modal__content-body h3 {
  margin: 16px 0 8px;
  font-weight: 700;
}

.notice-modal__content-body ul,
.notice-modal__content-body ol {
  padding-left: 20px;
  margin: 0 0 12px;
}

.notice-modal__content-body a {
  color: var(--home-navy);
  text-decoration: underline;
}

.notice-modal__content-body img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.notice-modal__content-body pre,
.notice-modal__content-body code {
  background: var(--fg-bg-content, #f2f2f2);
  border-radius: 4px;
}

.notice-modal__content-body pre {
  padding: 12px;
  overflow-x: auto;
}

.notice-modal__content-body code {
  padding: 1px 4px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;8CAC8C;AAC9C;EACE,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;EACnB,wBAAwB;;EAExB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,0DAA0D;AAC5D;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf;2BACyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,8DAA8D;AAChE;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mCAAmC;EACnC,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;;AAEnB,aAAa;AACb;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;EAClC,aAAa;EACb,uCAAuC;AACzC;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD;;4CAE0C;EAC1C,gBAAgB;EAChB,8DAA8D;EAC9D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,8BAA8B;EAC9B,SAAS;EACT,uBAAuB,EAAE,2BAA2B;EACpD,4CAA4C;EAC5C,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB,EAAE,+BAA+B;EACjD,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA;EACE,iCAAiC,EAAE,qBAAqB;EACxD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2CAA2C,EAAE,0BAA0B;AACzE;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,iCAAiC;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB,EAAE,6BAA6B;EACnD,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* ====== 사용자 홈 (에이전트 런처) ====== */\n\n/* 브랜드 네이비 로컬 토큰 — 랜딩(.landing)·제품(.gf-showcase-page)과 동일 값.\n   전역 토큰(보라 계열 primary/fg-purple)은 변경하지 않는다. */\n.home {\n  --home-navy: #13314f;\n  --home-navy-ink: #0e1b2b;\n  --home-navy-soft: #3c5a78;\n  --home-navy-tint: #e7edf3;\n  --home-navy-line: rgba(14, 27, 43, 0.1);\n  --home-gov: #1a5e3a;\n  --home-gov-tint: #e6f1ea;\n\n  min-height: 100vh;\n  background: var(--fg-bg-content, #f2f2f2);\n}\n\n.home__body {\n  padding: 40px 32px 64px;\n}\n.home__inner {\n  max-width: 1280px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n/* ── 인사 + 토큰 ── */\n.home-greet {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n.home-greet__hello {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--home-navy-ink);\n}\n.home-greet__hello b {\n  font-weight: 800;\n}\n.home-greet__sub {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n.home-greet__token {\n  min-width: 260px;\n}\n.home-greet__token-head {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 6px;\n}\n.home-greet__token-label {\n  color: var(--text-secondary);\n}\n.home-greet__token-pct {\n  font-weight: 700;\n  color: var(--home-navy);\n}\n.home-greet__token-pct.is-low {\n  color: var(--error, #dc2626);\n}\n.home-greet__token-bar {\n  height: 6px;\n  border-radius: 999px;\n  background: var(--home-navy-tint);\n  overflow: hidden;\n}\n.home-greet__token-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--home-navy);\n  transition: width 0.3s ease;\n}\n.home-greet__token-fill.is-low {\n  background: var(--error, #dc2626);\n}\n.home-greet__token-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.home-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.home-btn--primary {\n  background: var(--home-navy);\n  color: #fff;\n}\n.home-btn--primary:hover {\n  background: var(--home-navy-ink);\n}\n.home-btn--ghost {\n  background: #fff;\n  color: var(--home-navy);\n  border-color: var(--home-navy-line);\n}\n.home-btn--ghost:hover {\n  background: var(--home-navy-tint);\n}\n\n/* ── 섹션 헤더 ── */\n.home-section__head {\n  margin-bottom: 18px;\n}\n.home-section__head--row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.home-section__eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--home-navy-soft);\n}\n.home-section__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--home-navy-ink);\n}\n.home-section__title--sm {\n  font-size: 16px;\n}\n.home-section__sub {\n  margin: 8px 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n/* ── 에이전트 그리드 ── */\n.home-agent-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n}\n.home-agent-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, transform 0.15s ease,\n    border-color 0.15s ease;\n}\n.home-agent-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--home-navy-soft);\n  box-shadow: 0 12px 32px -16px rgba(14, 27, 43, 0.4);\n}\n.home-agent-card:focus-visible {\n  outline: none;\n  box-shadow: var(--focus-ring, 0 0 0 2px var(--home-navy-soft));\n}\n.home-agent-card--supplier {\n  border-color: var(--home-gov);\n}\n.home-agent-card__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.home-agent-card__mark {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n}\n.home-agent-card__mark img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home-agent-card__badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--home-navy);\n  background: var(--home-navy-tint);\n  border-radius: 999px;\n  padding: 3px 10px;\n}\n.home-agent-card__badge--gov {\n  color: var(--home-gov);\n  background: var(--home-gov-tint);\n}\n.home-agent-card__name {\n  margin: 2px 0 0;\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--home-navy-ink);\n}\n.home-agent-card__one {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.home-agent-card__starters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 2px;\n}\n.home-agent-card__starter {\n  font-size: 12px;\n  color: var(--home-navy);\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 999px;\n  padding: 5px 11px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.home-agent-card__starter:hover {\n  background: var(--home-navy-tint);\n}\n.home-agent-card__cta {\n  margin-top: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: var(--home-navy);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.home-agent-card__cta:hover {\n  background: var(--home-navy-ink);\n}\n\n.home-explore-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 20px;\n  background: transparent;\n  border: 1.5px dashed var(--home-navy-line);\n  border-radius: 14px;\n  color: var(--home-navy-soft);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.home-explore-card:hover {\n  border-color: var(--home-navy-soft);\n  background: #fff;\n}\n.home-explore-card__plus {\n  font-size: 24px;\n  line-height: 1;\n}\n\n/* ── 이어서 작업 ── */\n.home-resume__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n  gap: 12px;\n}\n.home-resume__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 12px;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.home-resume__item:hover {\n  border-color: var(--home-navy-soft);\n  box-shadow: 0 8px 20px -14px rgba(14, 27, 43, 0.4);\n}\n.home-resume__mark {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  display: inline-flex;\n}\n.home-resume__mark img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.home-resume__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.home-resume__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.home-resume__name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--home-navy-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.home-resume__status {\n  flex: 0 0 auto;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.5;\n  border: 1px solid transparent;\n}\n.home-resume__status--paused {\n  color: #1d4ed8;\n  background: #eff4ff;\n  border-color: #d3e0ff;\n}\n.home-resume__status--running {\n  color: #047857;\n  background: #ecfdf5;\n  border-color: #c8f0dd;\n}\n.home-resume__status--error {\n  color: #b42318;\n  background: #fef3f2;\n  border-color: #fbd6d1;\n}\n.home-resume__sum {\n  font-size: 12px;\n  color: var(--text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.home-resume__when {\n  flex: 0 0 auto;\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n.home-resume__empty {\n  margin: 0;\n  padding: 20px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--text-tertiary);\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 12px;\n}\n\n/* ── 모델 비교 배너 ── */\n.home-compare {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 22px;\n  background: var(--home-navy);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.home-compare:hover {\n  background: var(--home-navy-ink);\n}\n.home-compare__icon {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n}\n.home-compare__text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.home-compare__title {\n  font-size: 16px;\n  font-weight: 800;\n}\n.home-compare__sub {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.75);\n}\n.home-compare__go {\n  opacity: 0.8;\n}\n\n/* ── 공지사항 ── */\n.home-notice__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 12px;\n  overflow: hidden;\n}\n.home-notice__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-top: 1px solid var(--home-navy-line);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.home-notice__item:first-child {\n  border-top: none;\n}\n.home-notice__item:hover {\n  background: var(--home-navy-tint);\n}\n.home-notice__title {\n  font-size: 14px;\n  color: var(--home-navy-ink);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.home-notice__date {\n  flex: 0 0 auto;\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n.home-notice__empty {\n  margin: 0;\n  padding: 20px;\n  font-size: 14px;\n  color: var(--text-tertiary);\n  background: #fff;\n  border: 1px solid var(--home-navy-line);\n  border-radius: 12px;\n}\n\n/* ── 푸터 ── */\n.home-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding-top: 16px;\n  border-top: 1px solid var(--home-navy-line);\n  text-align: center;\n}\n.home-footer__links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 18px;\n}\n.home-footer__links a {\n  font-size: 13px;\n  color: var(--text-secondary);\n  text-decoration: none;\n}\n.home-footer__links a:hover {\n  color: var(--home-navy);\n}\n.home-footer__brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.home-footer__brand-img {\n  height: 22px;\n  object-fit: contain;\n}\n.home-footer__brand-img--bct {\n  height: 18px;\n  opacity: 0.85;\n}\n.home-footer__copy {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n/* ── 반응형 ── */\n@media (max-width: 720px) {\n  .home__body {\n    padding: 24px 16px 48px;\n  }\n  .home__inner {\n    gap: 32px;\n  }\n  .home-agent-grid {\n    grid-template-columns: 1fr;\n  }\n  .home-greet {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .home-greet__token {\n    min-width: 0;\n  }\n}\n\n/* ── 공지 상세 모달 ── */\n\n/* 등장 애니메이션 */\n@keyframes notice-overlay-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes notice-modal-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* 오버레이 — dialog와 sibling으로 분리, aria-hidden */\n.notice-modal__overlay {\n  position: fixed;\n  inset: 0;\n  /* 순수 블랙 → 브랜드 네이비 딥 오버레이 */\n  background: rgba(14, 27, 43, 0.55);\n  z-index: 1000;\n  animation: notice-overlay-in 0.18s ease;\n}\n\n/* 모달 패널 — div.notice-modal[role=\"dialog\"], 오버레이와 sibling */\n.notice-modal {\n  position: fixed;\n  inset: 24px;\n  margin: auto;\n  width: min(720px, calc(100% - 48px));\n  height: fit-content;\n  max-height: calc(80vh - 48px);\n  background: #ffffff;\n  border-radius: 14px;\n  display: flex;\n  flex-direction: column;\n  /* 네이비 기반 directional shadow — 홈 카드 hover 패턴 참조 */\n  box-shadow:\n    0 0 0 1px var(--home-navy-line),\n    0 24px 48px -16px rgba(14, 27, 43, 0.35);\n  overflow: hidden;\n  animation: notice-modal-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 1001;\n}\n\n.notice-modal__header {\n  display: flex;\n  align-items: flex-start; /* center → flex-start: 긴 제목 대응 */\n  justify-content: space-between;\n  gap: 12px;\n  padding: 22px 24px 18px; /* 좌우 24px — 카드 내부와 동일 리듬 */\n  /* border 대신 box-shadow로 — 스크롤 시 강화 전환을 위해 */\n  box-shadow: 0 1px 0 var(--home-navy-line);\n  transition: box-shadow 0.15s ease;\n}\n\n/* 바디 스크롤 시 헤더 하단 강조 */\n.notice-modal__header--scrolled {\n  box-shadow: 0 4px 12px -4px rgba(14, 27, 43, 0.12);\n}\n\n.notice-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800; /* 700 → 800: 홈 섹션 타이틀과 동급 위계 */\n  color: var(--home-navy-ink);\n  line-height: 1.4;\n  /* 단일행 ellipsis 제거 → 2줄 클램프 */\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.notice-modal__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  /* shorthand 대신 속성 명시 — 의도치 않은 전환 방지 */\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.notice-modal__close:hover {\n  background: var(--home-navy-tint); /* rgba 블랙 → 네이비 틴트 */\n  color: var(--home-navy-ink);\n}\n\n.notice-modal__close:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--home-navy-soft); /* 홈 카드 focus-visible 패턴 */\n}\n\n.notice-modal__body {\n  padding: 20px 24px 24px; /* 좌우 24px — 헤더와 수직 정렬 */\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px; /* 12px → 16px: 메타/설명/본문 간 숨 확보 */\n}\n\n.notice-modal__status {\n  margin: 0;\n  padding: 24px 0;\n  text-align: center;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.notice-modal__status--error {\n  color: var(--error, #dc2626);\n}\n\n.notice-modal__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.notice-modal__tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 999px; /* 9999px → 999px: 홈 배지와 통일 */\n  background: var(--home-navy-tint);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--home-navy);\n  line-height: 1;\n}\n\n.notice-modal__tag--pin {\n  background: var(--home-navy);\n  color: #ffffff;\n}\n\n.notice-modal__date {\n  margin-left: auto;\n  font-size: 13px;\n  color: var(--text-tertiary);\n}\n\n.notice-modal__description {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--home-navy-ink);\n  white-space: pre-wrap;\n}\n\n.notice-modal__content-body {\n  font-size: 14px;\n  line-height: 1.7;\n  color: var(--text-primary);\n  word-break: break-word;\n}\n\n.notice-modal__content-body p {\n  margin: 0 0 12px;\n}\n\n.notice-modal__content-body h1,\n.notice-modal__content-body h2,\n.notice-modal__content-body h3 {\n  margin: 16px 0 8px;\n  font-weight: 700;\n}\n\n.notice-modal__content-body ul,\n.notice-modal__content-body ol {\n  padding-left: 20px;\n  margin: 0 0 12px;\n}\n\n.notice-modal__content-body a {\n  color: var(--home-navy);\n  text-decoration: underline;\n}\n\n.notice-modal__content-body img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n}\n\n.notice-modal__content-body pre,\n.notice-modal__content-body code {\n  background: var(--fg-bg-content, #f2f2f2);\n  border-radius: 4px;\n}\n\n.notice-modal__content-body pre {\n  padding: 12px;\n  overflow-x: auto;\n}\n\n.notice-modal__content-body code {\n  padding: 1px 4px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
